<template>
    <v-form ref="formRecovery">
        <v-row>
            <v-col cols="12" class="mb-6">
                <v-row align="center" justify="center" class="flex-column">
                    <v-col cols="auto">
                        <v-img max-width="80px" contain src="/images/logo_roxo.png" />
                    </v-col>
                    <v-col cols="auto" class="text-center">
                        <span class="text-h5 font-weight-bold primary--text">Recuperar Senha</span><br>
                        <span class="text-body-2 secondary--text">Informe seu email para continuar</span>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12">
                <span class="text-caption secondary--text font-weight-bold ml-1">Email</span>
                <v-text-field
                    v-model="email_recovery"
                    placeholder="seu@email.com"
                    :rules="email_rules"
                    color="primary"
                    background-color="background"
                    filled
                    rounded
                    dense
                    height="48"
                    class="mt-1"
                />
            </v-col>
            <v-col cols="12" class="mt-4">
                <v-btn 
                    color="primary" 
                    block 
                    large 
                    elevation="0" 
                    class="white--text text-capitalize rounded-xl" 
                    :loading="loading_recovery" 
                    @click="recoverPassword"
                    height="48"
                >
                    Enviar Link
                </v-btn>
            </v-col>
            <v-col cols="12" class="text-center">
                <a class="text-caption primary--text font-weight-bold" @click="$emit('change-view', 'LoginForm')">Voltar para Login</a>
            </v-col>
        </v-row>

        <v-snackbar v-model="snackbar_show" :color="snackbar_color" top right rounded="xl">
            {{ snackbar_text }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar_show = false">Fechar</v-btn>
            </template>
        </v-snackbar>
    </v-form>
</template>

<script>
import { mapActions } from "vuex";

export default {
    data() {
        return {
            email_recovery: null,
            loading_recovery: false,
            email_rules: [
                v => !!v || "Digite um email",
                v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || "Digite um email válido"
            ],
            snackbar_show: false,
            snackbar_text: "",
            snackbar_color: ""
        };
    },
    methods: {
        ...mapActions("auth", ["ActionRecoverPassword"]),
        async recoverPassword() {
            if (this.$refs.formRecovery.validate()) {
                this.loading_recovery = true;
                try {
                    await this.ActionRecoverPassword({ email: this.email_recovery });
                    this.email_recovery = null;
                    
                    this.snackbar_text = "Email de recuperação enviado com sucesso!";
                    this.snackbar_color = "success";
                    this.snackbar_show = true;
                    
                    setTimeout(() => {
                        this.$emit('change-view', 'LoginForm');
                    }, 2000);
                } catch (error) {
                    const msg = error?.response?.data?.error || "Erro ao enviar email de recuperação";
                    this.snackbar_text = msg;
                    this.snackbar_color = "error";
                    this.snackbar_show = true;
                } finally {
                    this.loading_recovery = false;
                }
            }
        }
    }
};
</script>
